module.exports = __webpack_public_path__ + "static/media/default_avatar.18d3f60a.svg";